import React from "react";
import { Bell } from "lucide-react";
import { useLocation } from "react-router-dom";

import { getAuthClient } from "@tudigo-monorepo/core-tudigo-api";
import { useTranslation } from "@tudigo-monorepo/core-tudigo-translations";
import { ButtonRebrand } from "@tudigo-monorepo/web-tudigo-components";

import {
  ClubLeadersAvatar,
  ClubLeadersStats,
} from "../../club-avatar-leaders/club-leaders-avatar";

export const ClubMembershipModalUnauthenticatedContent = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const authClient = getAuthClient();
  const authUrl = authClient.authorizeUrl();

  const addRegisterQueryToUrl = (url: string) => {
    const urlObject = new URL(url);
    urlObject.searchParams.append("register", "1");

    return urlObject.toString();
  };

  const handleLogin = () => {
    localStorage.setItem("target-url", location.pathname);
    window.location.replace(authUrl);
  };

  const handleRegister = () => {
    localStorage.setItem("target-url", location.pathname);
    window.location.replace(addRegisterQueryToUrl(authUrl));
  };

  return (
    <div>
      <div className="m-4 flex flex-col items-center justify-center gap-4 rounded-lg border p-8">
        <h3 className="text-primary font-obviously text-lg font-bold">
          {t("circle_page.membership_button.modal.unauthenticated.title")}
        </h3>
        <p>
          {t("circle_page.membership_button.modal.unauthenticated.subtitle")}
        </p>
        <div className="flex gap-4">
          <ButtonRebrand
            className="rounded-full"
            variant="black"
            onClick={handleRegister}
          >
            {t("signup")}
          </ButtonRebrand>
          <ButtonRebrand
            className="rounded-full"
            variant="outline"
            onClick={handleLogin}
          >
            {t("login")}
          </ButtonRebrand>
        </div>
      </div>
      <div className="bg-light-3 m-4 flex flex-col items-center justify-center gap-4 rounded-lg border p-8">
        <h3 className="text-primary font-bold">
          {t("page_club.membership_modal.follow_circle_block.title")}
        </h3>
        <div className="flex flex-wrap items-center justify-center gap-2">
          <ClubLeadersAvatar />
          <ClubLeadersStats />
        </div>
        <ButtonRebrand className="rounded-full" variant="black" disabled>
          <Bell height={20} className="mr-2" />
          {t("page_club.membership_modal.follow_button.label")}
        </ButtonRebrand>
      </div>
    </div>
  );
};
